import * as React from 'react';
import { useSelector } from 'react-redux';

import { AnswerTextContainer } from './AnswerTextContainer';
import { NewAnswer } from '../../components/NewAnswer';
import { getError } from '../../selectors/newAnswer/getError';

interface INewAnswerContainerProps {
  userInfo?: React.ReactNode;
}

export const NewAnswerContainer = ({ userInfo }: INewAnswerContainerProps) => {
  const error = useSelector(getError);

  return (
    <NewAnswer
      userInfo={userInfo}
      answer={<AnswerTextContainer insertDefaultValue={false} />}
      anonymous={null}
      error={error}
    />
  );
};
